import ConfirmationDialog from './ConfirmationDialog';

export default ConfirmationDialog;
export * from './domain/confirmation-dialog-state.interface';